import axios from "axios"
import { getAuth } from "firebase/auth"

const BUG_REPORT_URL =
"https://europe-west3-hyper-e122e.cloudfunctions.net/bug_report"

const UPLOAD_URL =
"https://europe-west3-hyper-e122e.cloudfunctions.net/upload_image"

class SupportService {

  static async uploadBugScreenshot(file) {

    const auth = getAuth()
    const user = auth.currentUser

    if (!user) throw new Error("User not auth")

    const token = await user.getIdToken(true)

    const form = new FormData()

    form.append("type", "bug_report")
    form.append("user_id", user.uid)
    form.append("bug_image", file)

    const res = await axios.post(
      UPLOAD_URL,
      form,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )

    return res.data.url
  }

  static async sendBugReport(payload) {

    const auth = getAuth()
    const user = auth.currentUser

    const token = await user.getIdToken(true)

    const res = await axios.post(
      BUG_REPORT_URL,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )

    return res.data
  }

}

export default SupportService